function hideBootSplash() {
  const bootSplash = document.getElementById('boot-splash')
  if (bootSplash) bootSplash.remove()
}

export { hideBootSplash }
